// paso 1
export const LOGIN = {
  pageView: 'InitiateCheckout_login',
};

// paso 2
export const INITIAL_FORM = {
  pageView: 'InitiateCheckout_initialform',
};

// paso 3 - persona juridica
export const COMMERCE_FORM = {
  pageView: 'InitiateCheckout_commerce',
};

// paso 3 - persona natural
export const PERSON_FORM = {
  pageView: 'InitiateCheckout_person',
};

// paso 4 - persona juridica
export const REPRESENTANT_FORM = {
  pageView: 'InitiateCheckout_representant',
};

// paso 4 - persona natural
export const PERSON_DETAILS_FORM = {
  pageView: 'InitiateCheckout_persondetails',
};

// paso 5
export const DOCUMENT_FORM = {
  pageView: 'InitiateCheckout_documentform',
};

// paso 6
export const VALIDATION_FORM = {
  pageView: 'InitiateCheckout_validationmail',
};

// paso 7
export const VALIDATE_AND_CREATE_PASSWORD = {
  pageView: 'InitiateCheckout_validationpassword',
};

// paso 8
export const ACCOUNT_CREATED = {
  pageView: 'CompleteRegistration',
};
